import { Navigation } from "@/components/Navigation";
import { HeroSection } from "@/components/sections/HeroSection";
import ProductDemo from "@/components/sections/ProductDemo";
import { ProductPreviewSection } from "@/components/sections/ProductPreviewSection";
import { RitualSection } from "@/components/sections/RitualSection";
import { RecognitionSection } from "@/components/sections/RecognitionSection";
import { HowItWorksSection } from "@/components/sections/HowItWorksSection";
import { FounderSection } from "@/components/sections/FounderSection";
import { PhilosophySection } from "@/components/sections/PhilosophySection";
import { EarlyAccessSection } from "@/components/sections/EarlyAccessSection";
import { Footer } from "@/components/sections/Footer";

// Handwritten quote on torn notebook paper - positioned to overlap sections
const MakerQuote = () => (
  <div className="relative z-10 -mt-6 -mb-6 py-10 px-6 flex justify-center pointer-events-none">
    <div 
      className="relative max-w-lg mx-auto transform rotate-[0.6deg] pointer-events-auto"
    >
      {/* Paper with torn edges */}
      <div
        className="relative"
        style={{
          background: 'linear-gradient(to bottom, #FEF9E7 0%, #FDF6E3 100%)',
          padding: '24px 32px 28px 48px',
          boxShadow: '2px 3px 12px rgba(0,0,0,0.1), 0 1px 3px rgba(0,0,0,0.08)',
        }}
      >
        {/* Top torn edge */}
        <div 
          className="absolute -top-[6px] left-0 right-0 h-[12px] overflow-hidden"
          style={{ background: 'transparent' }}
        >
          <svg width="100%" height="12" preserveAspectRatio="none" viewBox="0 0 400 12">
            <path 
              d="M0,6 Q15,3 25,8 T50,4 T75,7 T100,5 T125,8 T150,4 T175,7 T200,5 T225,8 T250,4 T275,7 T300,5 T325,8 T350,4 T375,7 T400,5 L400,12 L0,12 Z" 
              fill="#FEF9E7"
            />
          </svg>
        </div>
        {/* Bottom torn edge */}
        <div 
          className="absolute -bottom-[6px] left-0 right-0 h-[12px] overflow-hidden"
          style={{ background: 'transparent' }}
        >
          <svg width="100%" height="12" preserveAspectRatio="none" viewBox="0 0 400 12">
            <path 
              d="M0,0 L400,0 L400,5 Q385,9 375,4 T350,7 T325,4 T300,8 T275,5 T250,7 T225,4 T200,8 T175,5 T150,7 T125,4 T100,8 T75,5 T50,7 T25,4 T0,7 Z" 
              fill="#FDF6E3"
            />
          </svg>
        </div>
        {/* Notebook lines */}
        <div 
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'repeating-linear-gradient(to bottom, transparent, transparent 27px, #E8DCCA 27px, #E8DCCA 28px)',
            backgroundPosition: '0 18px',
            opacity: 0.5,
          }}
        />
        {/* Red margin line */}
        <div 
          className="absolute top-0 bottom-0 left-10 w-[1px] pointer-events-none"
          style={{ backgroundColor: 'rgba(220, 100, 100, 0.3)' }}
        />
        {/* Text */}
        <p className="font-handwritten text-[1.35rem] md:text-[1.55rem] text-[#4A4540] leading-[1.8] relative z-10">
          "This isn't a complex task manager. It simplifies your day."
        </p>
      </div>
    </div>
  </div>
);

export default function LandingPage() {
  return (
    <main className="overflow-hidden">
      <Navigation />
      <div className="pt-16"> {/* Account for fixed nav */}
        <HeroSection />
        <ProductDemo />
        <HowItWorksSection />
        <ProductPreviewSection />
        <MakerQuote />
        <RitualSection />
        <RecognitionSection />
        <FounderSection />
        <PhilosophySection />
        <EarlyAccessSection />
        <Footer />
      </div>
    </main>
  );
}
